import _ from 'lodash';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { select, Store } from '@ngrx/store';
import { CampaignFormService } from '../../services';
import { selectBasketRaffleItemList } from '../../features/basketRaffle.selectors';
import { deleteBasketRaffleItems, updateBasketRaffleList } from '../../features/basketRaffle.actions';
import { CampaignBasketRaffleItemListService } from '../../services/campaign-basket-raffle-item-list.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-campaign-basket-raffle-item-list',
  templateUrl: './campaign-basket-raffle-item-list.component.html',
  styleUrls: ['./campaign-basket-raffle-item-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CampaignBasketRaffleItemListComponent implements OnInit, AfterViewInit {
  destroyRef = inject(DestroyRef)
  @ViewChild(CdkVirtualScrollViewport)
  public viewport: CdkVirtualScrollViewport;

  @Input()
  public index: number = 0;

  @Output() onEdit = new EventEmitter<any>();

  public list$ = this.store.pipe(
    select(selectBasketRaffleItemList),
  );

  public campaign = null
  public formGroup = null;

  public height: number = 83;
  public position: number = 0;
  public cdkDragStartedPosition = 0;
  public cdkDragEndedPosition = 0;

  public styles = { height: '83px' };

  constructor(
    private store: Store,
    public campaignFormService: CampaignFormService,
    public campaignBasketRaffleItemListService: CampaignBasketRaffleItemListService,
    public cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.formGroup = this.campaignFormService.campaignTypeData;
    this.campaign = this.campaignFormService.form;

    this.list$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((list) => {
      const { length } = list;
      this.campaignBasketRaffleItemListService.list = list;

      const height = length < 1 ? 83: length * 83;
  
      this.height = height > 830 ? 830: height;
      this.styles = { height: `${this.height}px` };

      this.cdr.markForCheck();
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      let indexToScroll = this.index - 1;
      if(this.index <= 3 ){
        indexToScroll = 0;
        return
      }
      this.viewport.scrollToIndex(this.index, "smooth");
    }, 500);
  }


  getBasketRaffleItemImageUrl(item) {
    return _.isEqual(item.image, '/images/blank_2x1.png') || _.isEqual(item.image, '') ?
      "/images/org_logo_default_v2.svg": item.image;
  }

  onCDKDragStarted(event) {
    this.cdkDragStartedPosition = this.position
  }

  onCDKDragEnded(event) {
    this.cdkDragEndedPosition = this.position
  }

  dropBasketRaffleItem(event, basketItems) {
    const { item: { data: { index: itemIndex } } }: any = event;

    const previousFoundIndex = _.findIndex(basketItems, element => {
      return element.index == itemIndex;
    });
    const currentFoundIndex = previousFoundIndex + (event.currentIndex - event.previousIndex);
    const currentIndex = basketItems[currentFoundIndex].index;

    moveItemInArray(basketItems, itemIndex, currentIndex);

    this.store.dispatch({
      type: updateBasketRaffleList.type,
      payload: {
        campaignId: this.campaign.value.id,
        basketItems: _.map(basketItems, ({ data }) => data)
      }
    });
  }

  editBasketRaffleItem({ data: basketItem, index }) {
    this.onEdit.next({ basketItem, index });
  }

  removeBasketRaffleItem(basketRaffleItem) {
    this.store.dispatch({
      type: deleteBasketRaffleItems.type,
      payload: {
        campaignId: this.campaign.value.id,
        basketItemIds: [basketRaffleItem.id]
      }
    });
  }

  moveTo(event: any, basketItems) {
    const position = parseInt(event.position);
    if(position >= 0 && basketItems.length > position) {
      moveItemInArray(basketItems, event.index, event.position);
      this.store.dispatch({
        type: updateBasketRaffleList.type,
        payload: {
          campaignId: this.campaign.value.id,
          basketItems: _.map(basketItems, ({ data }) => data)
        }
      });
    }
  }
}
